module.exports = __webpack_public_path__ + "static/media/linkedin-icon.e7399408.svg";